import React, { Component } from "react";
import { connect } from "react-redux";
import { getProducts } from "../actions/productActions";
import { setActivePage } from "../actions/pagerActions";
import { withRouter } from "react-router";
import { withTranslation } from 'react-i18next';

class Pager extends Component {
    onActivePageChanged(page) {
        const { settings } = this.props;
    this.props.setActivePage(page);
    this.props.getProducts(
      page,
      settings.pageSize,
        this.props.match.params.id,
        this.props.match.params.searchTerm);
  }

  render() {
    // if (!this.props.products) return <div />;

      const { t } = this.props;
    // const totalPages = this.props.products.totalPages;

    const { activePage, totalPages} = this.props.pager;

    const pageList = [...Array(totalPages)].map((x, i) => (
      <li key={i + 1} className={activePage === i + 1 ? "active" : ""}>
            <a  href={null} role="button" onClick={() => this.onActivePageChanged(i + 1)}>{i + 1}</a>
      </li>
    ));

    const prevClass = `column text-left hidden-xs-down ${
      activePage === 1 ? "btn-is-disabled" : ""
    }`;

    const nextClass = `column text-right hidden-xs-down ${
      activePage === totalPages ? "btn-is-disabled" : ""
    }`;

    return (
      <nav className="pagination">
        <div className={prevClass}>
                <a  href={null} role="button" 
            className="btn btn-outline-secondary btn-sm"
            onClick={() => this.onActivePageChanged(activePage - 1)}
          >
                    <i className="icon-arrow-left" />{t("Prev")}
          </a>
        </div>
        <div className="column">
          <ul className="pages">{pageList}</ul>
        </div>
        <div className={nextClass}>
                <a  href={null} role="button" 
            className="btn btn-outline-secondary btn-sm"
            onClick={() => this.onActivePageChanged(activePage + 1)} > {t("Next")}<i className="icon-arrow-right" />
          </a>
        </div>
      </nav>
    );
  }
}

function mapStateToProps({ products, settings, pager }) {
    return {products, settings, pager };
}

// export default connect(mapStateToProps, {
//   getProducts,
//   setActivePage
// })(Pager);

export default withTranslation()(withRouter(
  connect(mapStateToProps, {
    getProducts,
    setActivePage
  })(Pager))
);
